(() => {
  const final = document.querySelector('.ohmm-orange-final');
  const primaryPacks = document.querySelector('.ohmm-earbuds-packs');
  if (!final || !primaryPacks || final.dataset.bound) return;
  final.dataset.bound = 'true';
  const es = document.documentElement.lang.startsWith('es') || location.pathname.includes('auriculares-');
  const holder = final.querySelector('.ohmm-orange-final-packs');
  const submit = final.querySelector('.ohmm-orange-final-submit');
  const inputs = [...primaryPacks.querySelectorAll('input[type="radio"]')];
  const sync = () => {
    const input = inputs.find(i => i.checked);
    if (!input) return;
    const label = input.nextElementSibling;
    const q = Number(input.value), price = label.dataset.packPrice;
    holder.querySelectorAll('button').forEach(b => {b.setAttribute('aria-checked', String(b.dataset.quantity === input.value));});
    final.querySelector('[data-final-total]').textContent = price;
    submit.textContent = es ? `Añadir ${q} ${q === 1 ? 'pareja' : 'parejas'} — ${price}` : `Add ${q} ${q === 1 ? 'pair' : 'pairs'} to cart — ${price}`;
    const primary = document.querySelector('.product-form__submit');
    submit.disabled = !primary || primary.disabled;
  };
  inputs.forEach(input => {
    const label = input.nextElementSibling;
    const button = document.createElement('button');
    button.type = 'button';button.className = 'ohmm-orange-final-pack';button.dataset.quantity = input.value;
    button.setAttribute('role','radio');button.setAttribute('aria-label',label.textContent.trim().replace(/\s+/g,' '));
    button.innerHTML = label.querySelector('.quantity-break__content').innerHTML;
    button.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
    button.addEventListener('click',()=>{input.click();sync();});
    holder.appendChild(button);
  });
  primaryPacks.addEventListener('change',sync);
  submit.addEventListener('click',()=>{const primary=document.querySelector('.product-form__submit');if(primary&&!primary.disabled)primary.click();});
  submit.hidden=false;
  const primary = document.querySelector('.product-form__submit');
  if(primary)new MutationObserver(sync).observe(primary,{attributes:true,attributeFilter:['disabled']});
  sync();
})();
